// StudyDost — Refund Policy
// frontend/src/pages/RefundPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StaticPage, Section, Meta } from './PrivacyPage';

const LAST_UPDATED = 'May 3, 2026';

export default function RefundPage() {
  const navigate = useNavigate();
  return (
    <StaticPage title="Refund Policy" navigate={navigate}>
      <Meta>Last updated: {LAST_UPDATED}</Meta>

      <Section title="Overview">
        <p>We want you to be completely satisfied with StudyDost. This policy explains when and how you can request a refund. All refunds are processed in Indian Rupees (INR) to the original payment method within 5–7 business days.</p>
      </Section>

      <Section title="1. Subscription Plans (Monthly, Quarterly, Annual)">
        <p><strong>7-day money-back guarantee:</strong> If you subscribed to any paid plan and are not satisfied, you may request a full refund within 7 days of the initial purchase. No questions asked.</p>
        <p><strong>After 7 days:</strong> Refunds are not available for subscription fees already charged, except in cases of:</p>
        <ul>
          <li>Technical failure on our part that prevented you from using the service for more than 48 continuous hours</li>
          <li>Duplicate charges due to a payment processing error</li>
          <li>Charges made after a valid cancellation request</li>
        </ul>
        <p><strong>Renewals:</strong> If you forgot to cancel before a renewal, contact us within 48 hours of the renewal charge and we will issue a full refund, provided you have not used the service in that renewal period.</p>
      </Section>

      <Section title="2. Pay-Per-Question Credits (₹5)">
        <p>Pay-per-question credits are non-refundable once a question has been answered. If a credit was charged but no answer was delivered due to a technical error, we will either restore the credit to your account or issue a refund.</p>
      </Section>

      <Section title="3. Teacher Plans">
        <p>Teacher plan subscriptions (Basic and Pro) are eligible for a full refund within 7 days of purchase. After 7 days, refunds are not available for teacher plans, as the referral code and student access may already have been used.</p>
      </Section>

      <Section title="4. School Plans">
        <p>School plan refunds are handled on a case-by-case basis. Please contact us at billing@studydost.ai within 14 days of purchase to discuss.</p>
      </Section>

      <Section title="5. How to Request a Refund">
        <p>To request a refund, email us at <strong>billing@studydost.ai</strong> with:</p>
        <ul>
          <li>Your registered phone number</li>
          <li>The plan or purchase you are requesting a refund for</li>
          <li>The date of purchase</li>
          <li>Reason for the refund request (optional but helpful)</li>
        </ul>
        <p>We will respond within 2 business days. Approved refunds are processed within 5–7 business days to your original payment method.</p>
      </Section>

      <Section title="6. Cancellations">
        <p>You may cancel your subscription at any time from your Profile page or by contacting us. Cancellation stops future renewals but does not refund the current billing period (unless within the 7-day guarantee window).</p>
        <p>Your access continues until the end of your paid period after cancellation.</p>
      </Section>

      <Section title="7. Disputes">
        <p>If you believe you have been charged incorrectly, please contact us before initiating a chargeback with your bank. We resolve billing disputes quickly and chargebacks create delays. Contact: billing@studydost.ai</p>
      </Section>

      <Section title="8. Contact">
        <p><strong>Let's Redefine Private Limited</strong><br />
        Email: billing@studydost.ai<br />
        Website: studydost.ai<br />
        Noida, Uttar Pradesh, India</p>
      </Section>
    </StaticPage>
  );
}
